import AlertArea from "../prototype/ui/AlertArea.js";
import Commissioning from "../prototype/Commissioning.js";
import Configuration from "../prototype/Configuration.js";
import ConfirmationArea from "../prototype/ui/ConfirmationArea.js";
import Download from "../prototype/utils/Download.js";
import Error from "../prototype/utils/Error.js";
import FileInput from "../prototype/utils/FileInput.js";
import global from "../prototype/global.js";
import InputTextArea from "../prototype/ui/InputTextArea.js";
import InputCoordinatesArea from "../prototype/ui/InputCoordinatesArea.js";
import Internationalization from "../prototype/Internationalization.js";
import Server from "../prototype/Server.js";
import ToastArea from "../prototype/ui/ToastArea.js";

const log = global.log.getLogger("f_mtac_routes.admin");
log.setLevel(log.levels.DEBUG);

// declare variables for sorting user columns
const tbody = document.querySelector("#users_management tbody");
const th_sortable = $("#users_management th.sortable");
let table_rows;
let last_user; // save last user loaded

let is_default_admin_password = 1; //used to know if default password is used and must be changed
let is_enroll_password_created = 0; //used to know if the enrollment password has been initialised
let is_agnet_enabled = 0; //used to hide enrolment password bloc (not used in Agnet)

let selected_gis = 0;
let organization_id;

// @brief Create a user with all its attributes and save it in global.datastorage
var User = function (name, login, access_control, last_connection, msisdn) {
    // local variable for arguments
    let l_last_connection = last_connection;
    let l_msisdn = msisdn;

    let $user = $("<tr/>").attr({id: login});
    global.datastorage.put($user[0], "dataProfile", this);

    var $name = $("<td/>");
    var $last_connection = $("<td/>");
    var $msisdn = $("<td/>");
    var $access_control = $("<td/>");
    let $controls = $("<td/>");
    let $controls_group = $("<div/>")
        .attr({
            class: "btn-group",
            role: "group"
        })
        .appendTo($controls);
    $("<button/>")
        .attr({
            type: "button",
            class: "btn btn-sm btn-warning disconnect",
            "data-i18n-innerhtml": "user.disconnect", // i18n attribute allows live update on language modification
            "data-login": login
        })
        .text(global.internationalization.text("user.disconnect")) // init button text
        .appendTo($controls_group);
    $("<button/>")
        .attr({
            type: "button",
            class: "btn btn-sm btn-danger revoke",
            "data-i18n-innerhtml": "user.revoke", // i18n attribute allows live update on language modification
            "data-login": login
        })
        .text(global.internationalization.text("user.revoke")) // init button text
        .appendTo($controls_group);
    $user.append($name, $msisdn, $last_connection, $access_control, $controls);

    Object.defineProperty(this, "node", {
        set: () => {},
        get: () => $user
    });
    Object.defineProperty(this, "login", {
        set: () => {},
        get: () => login
    });
    Object.defineProperty(this, "name", {
        set: (new_name) => {
            name = new_name;
            $name.text(name);
            $name.attr({value: name}); //used for sorting
        },
        get: () => name
    });
    Object.defineProperty(this, "last_connection", {
        set: (date) => {
            l_last_connection = date;
            if (date != 0) {
                const time_date = new Date(date / 1000);
                $last_connection.text(`${global.internationalization.formatDateWithYear(time_date)} ${global.internationalization.formatTime(time_date)}`);
                $last_connection.attr({value: date}); // used for sorting
            } else {
                $last_connection.text("");
                $last_connection.attr({value: "0"});
            }
        },
        get: () => l_last_connection
    });
    Object.defineProperty(this, "msisdn", {
        set: (new_msisdn) => {
            l_msisdn = new_msisdn;
            $msisdn.text(l_msisdn);
            $msisdn.attr({value: l_msisdn}); //used for sorting
        },
        get: () => l_msisdn
    });
    Object.defineProperty(this, "access_control", {
        set: (new_access_control) => {
            access_control = new_access_control;
            const translation_key = {0: "global.None", 1: "user.Observer", 3: "user.Standard", 7: "user.Expert"}[access_control];
            $access_control
                .attr({
                    value: global.internationalization.text(translation_key) || "???", //used for sorting;
                    "data-i18n-innerhtml": translation_key // i18n attribute allows live update on language modification
                })
                .text(global.internationalization.text(translation_key) || "???");
        },
        get: () => access_control
    });
    this.name = name;
    this.msisdn = l_msisdn;
    this.access_control = access_control;
    this.last_connection = l_last_connection;
};

const init_language_dropdown = async () => {
    // Set button text
    $("#admin_language").text(global.configuration.internationalization.language.slice(-2));

    // Populate dropdown items
    let languages;
    try {
        languages = await global.server.mtac_language_list();
    } catch (error) {
        log.error("Error while fetching language list", error);
        return;
    }
    let dropdown = $("#dropdown_languages");
    languages = Object.values(languages.data.list);
    languages.forEach((lang) => (lang.text = global.internationalization.text(`language.${lang.name}`)));
    languages.sort((a, b) => (a.text < b.text ? -1 : a.text > b.text ? 1 : 0));
    languages.forEach((lang) => {
        $("<a>").addClass("dropdown-item").attr("value", lang.name).text(lang.text).appendTo($("<li>").appendTo(dropdown));
    });
};

function set_gis_type_and_key(type) {
    selected_gis = type;
    switch (type) {
        case 1:
            $("#admin_gis").text("Google Maps");
            $("#gis_key_setting").show();
            break;
        case 2:
            $("#admin_gis").text("OpenStreetMap");
            $("#gis_key_setting").hide();
            break;
        default:
            $("#admin_gis").text(global.internationalization.text("global.None"));
            $("#gis_key_setting").hide();
            break;
    }
}

function set_grid_reference(value) {
    $("#grid_reference input:checked").removeAttr("checked");
    $(`#grid_reference input[value='${value}']`).attr("checked", true);
}

const load_organization_settings = async (org_id) => {
    let organization;
    try {
        organization = await global.server.administration.load_organization_settings({org_id});
    } catch (error) {
        log.error("Error while fetching organization settings", error);
        return;
    }
    log.debug("organization ", organization);
    $("#org_id").text(organization.org_id);
    $("#org_name").text(organization.org_name);
    set_grid_reference(organization.grid);
    set_gis_type_and_key(organization.gis_type, organization.gis_key);
    $("#gis_key").text(organization.gis_key);
    $("#center_lon").text(organization.center_lon);
    $("#center_lat").text(organization.center_lat);
};

const select_tab = (tabID) => {
    switch (tabID) {
        case "tab1":
            $("#tab2").removeAttr("checked");
            $("#tab1").attr("checked", "checked");
            $("#configuration_panel").hide();
            $("#users_management_panel").show();
            break;
        case "tab2":
            $("#tab1").removeAttr("checked");
            $("#tab2").attr("checked", "checked");
            $("#users_management_panel").hide();
            $("#configuration_panel").show();
            break;
    }
};

const check_passwords = () => {
    log.debug("is_default_admin_password ", is_default_admin_password);
    $("#AdminPwdWarningBadge").toggle(is_default_admin_password);
    log.debug("is_enroll_password_created ", is_enroll_password_created);
    $("#EnrolmentPwdWarningBadge").toggle(!is_enroll_password_created);

    if (is_default_admin_password || (!is_agnet_enabled && !is_enroll_password_created)) {
        select_tab("tab2");
        // disable access to users and settings
        $("#tab1").attr("disabled", "");
        $("#organization_settings .accordion-button").attr("disabled", "");
    } else {
        $("#tab1").removeAttr("disabled");
        $("#organization_settings .accordion-button").removeAttr("disabled");
    }
};

const load_users = async ({from, limit}) => {
    let users;
    try {
        users = await global.server.administration.user_list({from, limit});
    } catch (error) {
        log.error("error while fetching users list", error);
        log.debug({from, limit});
        return;
    }

    if (users.data.count === 0) $("#no-enroled-users").show();
    else $("#no-enroled-users").hide();

    let user;
    for (let {name, login, access_control, last_connection, msisdn} of users.data.list) {
        const elem = document.getElementById(login);
        if (elem) {
            // element already displayed, update its attributes
            user = global.datastorage.get(elem, "dataProfile");
            if (user) {
                user.name = name;
                user.login = login;
                user.last_connection = last_connection;
                user.msisdn = msisdn;
            }
            continue;
        } else {
            user = new User(name, login, access_control, last_connection, msisdn);
            $("#admin_panel tbody").append(user.node);
        }
    }

    // keep last user for loading more users from him
    last_user = user;

    // update the list of rows for futur sorting
    hide_sorting_icons();

    // update the users count
    table_rows = $("tbody tr");
    $("#users_count").html(`(${table_rows.length} / ${users.data.count})`);

    // hide or not he msisdn column
    if (!users.data.agnet) hide_agnet_msisdn_columns();
};

// @brief hide the sorting icons of the user table titles
const hide_sorting_icons = () => {
    th_sortable.find("i").each((_, icon) => (icon.style.display = "none"));
};

// @brief hide the msisdn column (column no 1)
var hide_agnet_msisdn_columns = () => {
    const rows = document.querySelectorAll("#users_management table tr:not(#empty)");
    rows.forEach((tr) => (tr.cells[1].style.display = "none"));
};

function adapt_panel_to_available_height() {
    // Resize admin panel in case of header wrapping
    $("#admin_panel").css("--header_height", $("#admin_panel header").outerHeight() + "px");
}

var init = async () => {
    global.configuration = new Configuration();
    await global.configuration.init();
    global.server = new Server();
    global.server.authentication.auto_register = false;
    await global.server.init();
    await global.app.service_worker.register(); // to profit from application update detection
    global.app.theme.apply_theme(global.app.theme.get_preferred_theme());
    global.internationalization = new Internationalization(true);
    await global.internationalization.init();

    const submit = async () => {
        const passphrase = $("#admin_login input#password").val();
        const org_id = $("#admin_login input#organization").val();
        try {
            let response = await global.server.administration.login({passphrase, org_id});
            log.debug("response.data ", response.data);
            is_default_admin_password = response.data.default_password_in_use;
            is_enroll_password_created = response.data.enroll_password_exists;
            is_agnet_enabled = response.data.agnet;
        } catch (error) {
            log.debug(error.status);
            switch (error.status) {
                case Error.status.invalid:
                case Error.status.access:
                case Error.status.auth:
                    $("#admin_login #error_message").text(global.internationalization.text("admin.organization-or-password-invalid"));
                    return;
                default:
                    $("#admin_login #error_message").text(error.message);
                    return;
            }
        }
        global.commissioning = new Commissioning();
        global.commissioning.organization = $("#admin_login input#organization").val().toLowerCase();
        fetch(global.commissioning.uri.logo)
            .then((logo) => logo.text())
            .then((logo_text) => new DOMParser().parseFromString(logo_text, "application/xml"))
            .then((logo) => $("#admin_panel .logo")[0].append(logo.documentElement))
            .catch((error) => log.error(error));

        check_passwords();
        if (is_agnet_enabled) $("#enrolment_password_setting").hide();
        init_language_dropdown();
        load_users({});
        load_organization_settings(org_id);
        $("#admin_login").hide();
        $("#admin_panel").show();
        adapt_panel_to_available_height();
        organization_id = org_id;
    };

    // Page events handling
    // ----------------------
    window.onresize = () => adapt_panel_to_available_height();

    // Login events handling
    // ----------------------
    $("body").on("click", "#admin_login button", (event) => {
        event.preventDefault();
        submit();
    });

    $("body").on("keydown", "#admin_login input", (event) => {
        $("#admin_login #error_message").text("");
        if (event.key === "Enter") {
            event.preventDefault();
            submit();
        }
    });

    // Navbar events handling
    // ----------------------
    $("body").on("click", "#tabs > input", (event) => select_tab(event.currentTarget.id));

    $("body").on("click", "#dropdown_languages > li", async (event) => {
        const selected_language = event.currentTarget.querySelector(".dropdown-item").getAttribute("value");
        $("#admin_language").text(selected_language.slice(-2));
        await global.internationalization.changeLanguage(selected_language);
        document.querySelectorAll("#users_management tbody tr").forEach(($el) => {
            let user = global.datastorage.get($el, "dataProfile");
            const last_connection_date = user.last_connection;
            user.last_connection = last_connection_date;
        });
    });

    $("body").on("click", "#admin_logout", async () => {
        await global.server.administration.logout();
        window.location.replace(`${window.location.origin}/mtac/admin`);
    });

    // Users management events handling
    // --------------------------------
    $("body").on("click", "#load_more_users", async () => {
        $("#load_more_users").prop("disabled", true);
        try {
            await load_users({from: last_user?.login});
        } catch (error) {
            log.error("failed to load more users", error);
        }
        $("#load_more_users").prop("disabled", false);
    });

    $("body").on("click", "#admin_panel tbody button.disconnect", async (event) => {
        const confirmation = await ConfirmationArea.interact({
            title: global.internationalization.text("global.Confirmation"),
            tip1: global.internationalization.text("user.disconnection-confirmation")
        });
        if (!confirmation) {
            return;
        }
        const login = $(event.currentTarget).data("login");
        $(event.currentTarget).prop("disable", true);
        try {
            await global.server.administration.user_disconnect({login});
        } catch (error) {
            AlertArea.interact({type: "danger", tip1: global.internationalization.text("user.disconnection-failure")});
        }
        $(event.currentTarget).prop("disable", false);
    });

    $("body").on("click", "#admin_panel tbody button.revoke", async (event) => {
        const confirmation = await ConfirmationArea.interact({
            title: global.internationalization.text("global.Confirmation"),
            tip1: global.internationalization.text("user.revoking-confirmation")
        });
        if (!confirmation) {
            return;
        }
        const login = $(event.currentTarget).data("login");
        $(event.currentTarget).prop("disable", true);
        try {
            await global.server.administration.user_deregister({login});
        } catch (error) {
            AlertArea.interact({type: "danger", tip1: global.internationalization.text("user.revoking-failure")});
            $(event.currentTarget).prop("disable", false);
            return;
        }
        $(event.currentTarget).parents("tr").remove();
        if (last_user.login === login) last_user = null;
    });

    $("body").on("click", "#export_users", async () => {
        try {
            var users_export_blob = await global.server.administration.admin_users_export();
        } catch (error) {
            log.error(error);
            AlertArea.interact({type: "danger", tip1: global.internationalization.text("admin.export-users-error")});
            return;
        }
        Download.blob(users_export_blob, "export.json");
    });

    var import_file_input = new FileInput();
    $("body").on("click", "#import_users", async () => {
        var import_file = await import_file_input.select({});
        if (import_file === null) {
            log.debug("import file null");
            return;
        }
        try {
            await global.server.administration.admin_users_import({import_data: import_file});
        } catch (error) {
            log.error(error.message);
            AlertArea.interact({type: "danger", tip1: global.internationalization.text("admin.import-users-error")});
            return;
        }
        ToastArea.interact("success", global.internationalization.text("admin.Users-import-success"));
        load_users({});
    });

    // Manage sorting of columns
    // -------------------------

    // @brief row comparison based on text content
    // @param col index of the column to be sorted
    // @param asc true for ascendant, false for descendant
    const compare = function (col, asc) {
        // @params row1 and row2 are provided by the sort() method
        return function (row1, row2) {
            const tdValue = (row, col) => row.children[col].getAttribute("value");
            let v1 = tdValue(asc ? row1 : row2, col);
            let v2 = tdValue(asc ? row2 : row1, col);
            const compare_numbers = typeof v1 === "number" && typeof v2 === "number";
            return compare_numbers ? v1 - v2 : v1.toString().localeCompare(v2);
        };
    };

    // Add sorting feature on table titles when clicked
    th_sortable.each((index, th) => {
        th.addEventListener("click", function () {
            hide_sorting_icons();

            // apply sorting
            let sorted = Array.from(table_rows).sort(compare(index, (this.asc = !this.asc)));
            sorted.forEach((tr) => tbody.appendChild(tr));

            // update angle icon display
            let icon = th.querySelector("i");
            icon.className = this.asc ? "f_mtac-icon-angle-up-white" : "f_mtac-icon-angle-down-white";
            icon.style.display = "inline-flex";
        });
    });

    // Configuration events handling
    // -----------------------------
    $("body").on("click.admin_password_form.btn", "#admin_password_form .btn", async () => {
        const old_password = $("#admin_password_form input#old_admin_password").val();
        const new_password = $("#admin_password_form input#new_admin_password").val();
        const repeat_new_password = $("#admin_password_form input#repeat_new_admin_password").val();
        log.debug({old_password, new_password, repeat_new_password});
        if (old_password === "") $("#admin_password_form input#old_admin_password").addClass("is-invalid");
        if (new_password === "") $("#admin_password_form input#new_admin_password").addClass("is-invalid");
        if (new_password !== repeat_new_password) $("#admin_password_form input#repeat_new_admin_password").addClass("is-invalid");
        if (old_password === "" || new_password === "" || new_password !== repeat_new_password) return;
        try {
            const response = await global.server.administration.admin_passphrase({org_id: organization_id, old_password, new_password});
            is_default_admin_password = response.data.default_password_in_use;
            log.debug({is_default_admin_password});
        } catch (error) {
            log.error(error.message);
            switch (error.status) {
                case Error.status.access:
                case Error.status.auth:
                    $("#admin_password_form input#old_admin_password").addClass("is-invalid");
                    break;
                default:
                    // TODO: Add translation key
                    AlertArea.interact({type: "danger", tip1: global.internationalization.text("admin.admin-password-modification-error")});
            }
            return;
        }
        $("#admin_password_form input").val("");
        check_passwords();
        ToastArea.interact("success", global.internationalization.text("admin.admin-password-modification-confirmation"));
    });
    $("body").on("keydown.admin_password_form.input", "#admin_password_form input", (event) => {
        $(event.currentTarget).removeClass("is-invalid");
    });

    // Enrollment password setting event
    $("body").on("click.enrolment_password_form.btn", "#enrolment_password_form .btn", async () => {
        const admin_password = $("#enrolment_password_form input#admin_password").val();
        const new_password = $("#enrolment_password_form input#new_enrolment_password").val();
        const repeat_new_password = $("#enrolment_password_form input#repeat_new_enrolment_password").val();
        log.debug({admin_password, new_password, repeat_new_password});
        if (admin_password === "") $("#enrolment_password_form input#admin_password").addClass("is-invalid");
        if (new_password === "") $("#enrolment_password_form input#new_enrolment_password").addClass("is-invalid");
        if (new_password !== repeat_new_password) $("#enrolment_password_form input#repeat_new_enrolment_password").addClass("is-invalid");
        if (admin_password === "" || new_password === "" || new_password !== repeat_new_password) return;
        try {
            await global.server.administration.enrollment_passphrase({admin_password, new_password});
        } catch (error) {
            log.error(error.message);
            switch (error.status) {
                case Error.status.access:
                case Error.status.auth:
                    $("#enrolment_password_form input#admin_password").addClass("is-invalid");
                    break;
                default:
                    // TODO: Add translation key
                    AlertArea.interact({type: "danger", tip1: global.internationalization.text("admin.enrolment-password-modification-error")});
            }
            return;
        }
        $("#enrolment_password_form input").val("");
        is_enroll_password_created = 1;
        check_passwords();
        ToastArea.interact("success", global.internationalization.text("admin.enrolment-password-modification-confirmation"));
    });
    $("body").on("keydown.enrolment_password_form.input", "#enrolment_password_form input", (event) => {
        $(event.currentTarget).removeClass("is-invalid");
    });

    // Org settings actions handlers and listeners
    const submit_org_settings = async ({org_name, gis_type, gis_key, grid, center_lon, center_lat}) => {
        try {
            await global.server.administration.update_organization_settings({org_id: organization_id, org_name, gis_type, gis_key, grid, center_lon, center_lat});
        } catch (error) {
            log.error(error.message);
            // TODO: Add translation key
            AlertArea.interact({type: "danger", tip1: global.internationalization.text("admin.organization-settings-modification-error")});
            return false;
        }
        ToastArea.interact("success", global.internationalization.text("admin.organization-settings-modification-confirmation"));
        return true;
    };

    // Org name setting event
    $("body").on("click.org_name_setting.btn", "#org_name_setting .btn", async () => {
        const new_name = await InputTextArea.interact({
            current_text: $("#org_name").text(),
            tip: global.internationalization.text("admin.organization-rename-title"),
            validators: {required: true, pattern: "[\\S ]+"}
        });
        if (!new_name) return;
        const submitted = submit_org_settings({org_name: new_name});
        if (submitted) $("#org_name").text(new_name);
    });

    // Grid type setting event
    $("body").on("click", "#grid_reference input", (event) => {
        const value = parseInt(event.currentTarget.value);
        const submitted = submit_org_settings({grid: value});
        if (submitted) set_grid_reference(value);
    });

    // GIS type setting event
    $("body").on("click", "#dropdown_gis > li", async (event) => {
        const value = parseInt(event.currentTarget.querySelector(".dropdown-item").getAttribute("value"));
        const submitted = submit_org_settings({gis_type: value});
        if (submitted) set_gis_type_and_key(value);
    });

    // GIS key setting event
    $("body").on("click.gis_key_setting.btn", "#gis_key_setting .btn", async () => {
        const new_key = await InputTextArea.interact({
            current_text: $("#gis_key").text(),
            tip: global.internationalization.text("admin.gis-key")
        });
        if (new_key === null) return;
        const submitted = submit_org_settings({gis_type: selected_gis, gis_key: new_key});
        if (submitted) $("#gis_key").text(new_key);
    });

    // GIS center setting event
    $("body").on("click.org_center_setting.btn", "#org_center_setting .btn", async () => {
        const lon = $("#org_center_setting #center_lon").text();
        const lat = $("#org_center_setting #center_lat").text();
        log.debug({E: lon, N: lat});
        const coords = await InputCoordinatesArea.interact({E: lon, N: lat});
        log.debug("Before:", {E: parseFloat(lon), N: parseFloat(lat)}, "After:", coords);
        if (!coords) return;
        const submitted = submit_org_settings({center_lon: coords.E, center_lat: coords.N});
        if (!submitted) return;
        $("#org_center_setting #center_lon").text(coords.E);
        $("#org_center_setting #center_lat").text(coords.N);
    });

    // Display form only when ready to avoid test issue
    $("#admin_login form").show();
};
var finalize = () => {};

export default {init, finalize};
